import { useState, useEffect } from 'react';
import BaseContainer from '@/components/baseContainer';
import RegisterEmailForm, { RegisterEmailFormData } from '@/components/form/registerEmailForm';
import { API_BASE_URL, WP_URL } from '@/config';
import RegisterAgreementForm, { RegisterAgreementFormData } from '@/components/form/registerAgreementForm';
import RegisterRequestForm, { RegisterRequestFormData } from '@/components/form/registerRequestForm';
import RegisterBasicForm, { RegisterBasicFormData } from '@/components/form/registerBasicForm';
import { linkToIframe } from '@/utiils';
import { useCookies } from 'react-cookie';
import { setLoginCookies } from '@/lib/sessionCookie'; 

const RegisterPage = () => {
  const cookieMaxAge = 90 * 24 * 60 * 60; // 90日
  const [cookies, setCookie] = useCookies();
 
  const [presetEmail, setPresetEmail] = useState('');
  const [presetCode, setPresetCode] = useState('');
  // const [presetPassword, setPresetPassword] = useState('');
  const [enableNextStep, setEnableNextStep] = useState(false);
  const [basicFormData, setBasicFormData] = useState<{isValid: boolean, formData: RegisterBasicFormData | undefined}>({isValid: false, formData: undefined});
  const [basicFormShouldSubmit, setBasicFormShouldSubmit] = useState(false);
  const [requestFormData, setRequestFormData] = useState<{isValid: boolean, formData: RegisterRequestFormData | undefined}>({isValid: false, formData: undefined});
  const [requestFormShouldSubmit, setRequestFormShouldSubmit] = useState(false);
  const [agreementFormData, setAgreementFormData] = useState<{isValid: boolean, formData: RegisterAgreementFormData | undefined}>({isValid: false, formData: undefined});
  const [agreementFormShouldSubmit, setAgreementFormShouldSubmit] = useState(false);

  const isFormValid = basicFormData.isValid && requestFormData.isValid && agreementFormData.isValid;

  const onRegisterEmailComplete = (data: RegisterEmailFormData) => {
    setPresetEmail(data.email);
    setPresetCode(data.code);
    //setPresetPassword(data.password);
    setEnableNextStep(true);
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const cookieLoginMaxAge =  2 * 30 * 60; // 3600秒
    e.preventDefault();
    if( !isFormValid ) {
      setBasicFormShouldSubmit(true);
      setRequestFormShouldSubmit(true);
      setAgreementFormShouldSubmit(true);
      setTimeout(() => {
        const firstError = document.querySelector('.m-form-item__error');
        if( firstError ) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setBasicFormShouldSubmit(false);
        setRequestFormShouldSubmit(false);
        setAgreementFormShouldSubmit(false);
      }, 100);
      return;
    }
    const pwd = basicFormData.formData?.password ?? '';
    const pwdConfirm = basicFormData.formData?.password_confirm ?? pwd;

    const body = {
      ...basicFormData.formData,
      ...requestFormData.formData,
      ...agreementFormData.formData,
      email: presetEmail,
      verification_code:presetCode,
      password: pwd,
      password_confirm: pwdConfirm,
      zip_second: '',
      address_second: '',
      amc: requestFormData.formData?.amc ?? '',
      industry_other: basicFormData.formData?.industry_other ?? '',
      purpose_other: requestFormData.formData?.purpose_other ?? '',
      condition_no_home: true,
      condition_not_single_transfer: true,
      condition_not_care: true,
    };

    // const username = "2chiiki-prod";
    // const password = "FJt.QqCaN.+3";
    const username = "2chiiki-stg-wp"
    const password = "DNt~VqC*N.-5"
    const basicAuth = btoa(`${username}:${password}`);
    fetch(`${API_BASE_URL}/v1/user/register`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Basic ${basicAuth}`      
      },
      body: JSON.stringify(body),
    })
      .then(res => {
        if (!res.ok) {
          return res.json().then(errorData => {
            console.error('エラー詳細:', errorData);
            throw new Error(errorData.error || '登録に失敗しました');
          });
        }
        return res.json();
      })
      .then(data => {
        if (!data.token) throw new Error('トークンが返されませんでした');  
        localStorage.setItem('token', data.token);
        setCookie('lastLogin', 'true', {
          path: '/',
          maxAge: cookieMaxAge,
          secure: true,
          sameSite: 'strict',
        });
        // ログイン成功時にサーバーが ak_auth を Set-Cookie する前提
        // document.cookie = `ak_logged_in=1; Path=/; Max-Age=${cookieLoginMaxAge}; Secure; SameSite=Lax`;
        // document.cookie = `ak_logged_in=1; Path=/; Max-Age=${cookieLoginMaxAge}; Secure; SameSite=Lax`;
        setLoginCookies(cookieLoginMaxAge);
        console.log('API response', data);

        alert('登録が完了しました');
        linkToIframe('', { isIframeUrl: `${WP_URL}` });
      })
      .catch(err => {
        alert(err.message);
      });
  };

  return (
      <div className="py-16">
        <div className="flex flex-col">
          <BaseContainer>
            <div className="xmd:w-[80rem] mx-auto">
              {/* <p className="m-form-title mb-8">STEP 1: メール認証とパスワード設定</p> */}
              {/* <p className="m-form-title mb-8 m-icon-step1">STEP 1: メール認証</p> */}
              <p className="m-form-title mb-2 m-step1 with-icon">：メール認証</p>
              <div className="max-w-[64rem] mx-auto"><br></br>
                <RegisterEmailForm onComplete={onRegisterEmailComplete} />
              </div>
            </div>
          </BaseContainer>
        </div>
        <form onSubmit={onSubmit}>
        <div className="flex flex-col gap-8 pt-8">
        <BaseContainer>
          <div className="xmd:w-[80rem] mx-auto flex flex-col gap-8">
            {/* 見出し＋右端注記 */}
            <div className="flex items-center justify-between">
              <p className="m-form-title mb-2 m-step2 with-icon">
                ：基本情報入力
                {/* Step2：基本情報入力 */}
              </p>
              <span className="text-s text-slate-500 whitespace-nowrap">
              <span className="required">*</span>入力必須項目
              </span>
            </div>

            <RegisterBasicForm
              enabled={enableNextStep}
              onValidationChange={setBasicFormData}
              shouldSubmit={basicFormShouldSubmit}
            />
          </div>
        </BaseContainer>

          <BaseContainer>
            <div className="xmd:w-[80rem] mx-auto flex flex-col gap-8">
              {/* <p className="m-form-title mb-2">STEP 3: 自治体の申請</p> */}
              <RegisterRequestForm enabled={enableNextStep} onValidationChange={setRequestFormData} shouldSubmit={requestFormShouldSubmit} />
            </div>
          </BaseContainer>
          <BaseContainer>
            <div className="xmd:w-[80rem] mx-auto flex flex-col gap-8">
              {/* 見出し＋右端注記 */}
              <div className="flex items-center justify-between">
                <p className="m-form-title mb-2 m-step3 with-icon">
                  {/* Step3：規約・プライバシーポリシー同意 */}
                  ：利用規約同意
                </p>
                <span className="text-s text-slate-500 whitespace-nowrap">
                  <span className="required">*</span>入力必須項目
                </span>
              </div>

              <RegisterAgreementForm
                enabled={enableNextStep}
                onValidationChange={setAgreementFormData}
                shouldSubmit={agreementFormShouldSubmit}
              />
            </div>

            <div className="flex justify-center mt-12">
              {/* ボタンのdisabled条件は isFormValid に合わせるのが自然 */}
              <button
                type="submit"
                className={`m-btn fill ${!isFormValid ? 'disabled' : ''}`}
                disabled={!isFormValid}
              >
                利用登録する
              </button>
            </div>
          </BaseContainer>

        </div>
        </form>
      </div>
  );
}
export default RegisterPage;